import { render, staticRenderFns } from "./ProfileTier.vue?vue&type=template&id=7c14942a&scoped=true&"
import script from "./ProfileTier.vue?vue&type=script&lang=js&"
export * from "./ProfileTier.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTier.vue?vue&type=style&index=0&id=7c14942a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c14942a",
  null
  
)

export default component.exports